export const GET_STATE_MAILING_SUCCESS = 'GET_STATE_MAILING_SUCCESS'

export const getStateMailingSuccess = (value) => {
  return {
    type: GET_STATE_MAILING_SUCCESS,
    data: value,
  }
}
